/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-dot': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 32',
    data: '<metadata id="metadata18"/><path pid="0" id="path3346" d="M11.119 17.017A3.119 3.119 0 018 20.136a3.119 3.119 0 01-3.119-3.12A3.119 3.119 0 018 13.899a3.119 3.119 0 013.119 3.119z" _fill="#000" fill-opacity="1" fill-rule="evenodd" _stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-opacity="1"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-dot.js